import { Trans } from "@lingui/react/macro"

export function Loading() {
  return (
    <div>
      <div className="loading" css="ml-2 mt-2 text-[15px] opacity-80">
        <Trans>Loading</Trans>
      </div>
    </div>
  )
}
